import {makeStyles} from "@material-ui/styles";
import {Button, Container, Grid, List, ListItem} from "@material-ui/core";
import TextContent from "../text/text-content";
import Link from "next/link";
import React, {useContext} from "react";
import {useRouter} from "next/router";
import theme from "../../../theme";
import {useTranslation} from "tools/i18n";
import {TrackingContext} from "../../../providers/tracking";

const useStyles = makeStyles(() => ({
	wrapper: {
		padding: '40px 0',
		backgroundColor: 'white'
	},
    bottomDescription: {
		'& div': {
			color: '#212121 !important',
		},
        '& h2': {
            marginBottom: 0
        },
		'& h3': {
			marginBottom: 0
		},
		'& ul': {
			margin: '10px 0 0 0',
			'& li': {
				margin: 0
			}
		},
		'& a': {
			color: 'inherit'
		},
		[theme.breakpoints.down('md')]: {
			textAlign: 'center',
			marginBottom: 20
		},
		[theme.breakpoints.up('md')]: {
			paddingRight: 20
		}
    },
    links: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'flex-start',
		textAlign: 'center'
	},
    linksList: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexWrap: 'wrap',
        gap: 15,
		paddingBottom: 5,
		minWidth: 0,
		maxWidth: 400,
		'& h3': {
			width: '100%',
			margin: 0,
			...theme.typography.h3,
			fontSize: 22,
			lineHeight: 1.7,
		}
	},
    navigationButton: {
		padding: '8px 20px',
		color: '#212121',
		backgroundColor: '#ffffff',
		borderRadius: 0,
        fontSize: 12,
		letterSpacing: 0.5,
		whiteSpace: 'nowrap',
		boxShadow: theme.boxShadow[1],
		'&.active': {
			backgroundColor: '#212121',
			color: 'white'
		}
	}
}),  {name: 'CategoryBottomSection'});

export default function CategoryBottomSection({category, categoryMenu}) {
    const router = useRouter();
    const classes = useStyles();
	const {t} = useTranslation(['general']);
	const {actions: trackingActions} = useContext(TrackingContext);

    function isMatchingCategoryUrl(routerPath, categoryUrl) {
		let routerPathWithoutQuery = routerPath.split('?')[0];

		return routerPathWithoutQuery === categoryUrl;
	}

    function getLinks() {
		const menuItems = categoryMenu || false;

		if(!menuItems || menuItems.length < 1) {
			return '';
		}

		return (
			<List className={classes.linksList} disablePadding>
				<h3>{t('see-more')}</h3>
				{menuItems.filter((category) => category.type === 'page').map((category, index) => {
					return (
						<ListItem style={{width: 'auto', padding: 0}} key={index} disableGutters>
							<Link href={category.url}>
								<a>
									<Button
										className={[classes.navigationButton, isMatchingCategoryUrl(router.asPath, category.url) ? 'active' : ''].join(' ')}
										onClick={() => trackingActions.click({
											type: 'category_bottom_link',
											text: category.name,
											identifier: category.url
										})}
									>{category.name}</Button>
								</a>
							</Link>
						</ListItem>
					);
				})}
			</List>
		);
	}

    return (
		<div className={classes.wrapper}>
			<Container>
				<Grid justify={'center'} container>
					{category.translated?.customFields?.bottom_description ? <Grid className={classes.bottomDescription} xs={12} lg={6} item>
						<TextContent content={category.translated?.customFields?.bottom_description}/>
					</Grid>  : ''}
					<Grid className={classes.links} xs={12} lg={6} item>
						{getLinks()}
					</Grid>
				</Grid>
			</Container>
		</div>
    );
}
